var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_vm._l((_vm.sections),function(section){return [_c('a',{key:section,class:{ isActive: section === _vm.activeSection },attrs:{"href":'#' + section}},[_vm._v(_vm._s(_vm.titles[section]))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }